<style src='animate.css/animate.css'></style>

<template>
    <div style="height: 1px">
                <span v-if="isBusy" class="animated flip infinite"
                      style="color: white; margin-left: 50%; !important;">{{text}}</span>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import WhenInViewPort from 'when-in-viewport'

  export default {
    name: 'InfiniteScroll',
    props: {
      isBusy: Boolean,
      hasMore: Boolean,
      loader: Function,
      text: String
    },

    data: function() {
      return {
        viewPortHandler: null,
      };
    },

    computed: {},

    mounted()
    {
      this.viewPortHandler = new WhenInViewPort(this.$el, this.handleScroll);
    },

    destroyed()
    {
      this.viewPortHandler.stopListening();
    },


    methods: {
      handleScroll(ev)
      {
        if (this.isBusy)
          return;

        this.loader();
      },
    }
  }
</script>